(() => {
  if (window.mcShippingEstimateReady) return;
  window.mcShippingEstimateReady = true;
  const revisions = new WeakMap();
  const clear = panel => {
    revisions.set(panel, (revisions.get(panel) || 0) + 1);
    panel.querySelector('[data-mc-result]').textContent = '';
  };
  document.addEventListener('click', event => {
    if (event.target.closest('[cart-counter-increment],[cart-counter-decrement],[data-product-remove],[data-quantity-plus-btn],[data-quantity-minus-btn],[data-remove],[add-to-cart-button]')) document.querySelectorAll('[data-mc-shipping]').forEach(clear);
  }, true);
  document.addEventListener('change', event => {
    const panel = event.target.closest('[data-mc-shipping]');
    if (panel) clear(panel);
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-mc-calculate]');
    if (!button || button.disabled) return;
    const panel = button.closest('[data-mc-shipping]');
    const result = panel.querySelector('[data-mc-result]');
    const country = panel.querySelector('[data-mc-country]').value;
    if (!country) { result.textContent = panel.dataset.error; panel.querySelector('select').focus(); return; }
    const params = new URLSearchParams({
      'shipping_address[country]': country,
      'shipping_address[zip]': panel.querySelector('[data-mc-zip]').value.trim(),
      'shipping_address[province]': panel.querySelector('[data-mc-province]').value.trim()
    });
    const root = window.Shopify?.routes?.root || '/';
    const revision = revisions.get(panel) || 0;
    button.disabled = true;
    result.textContent = panel.dataset.loading;
    try {
      const prepared = await fetch(root + 'cart/prepare_shipping_rates.json?' + params, {method:'POST', headers:{Accept:'application/json'}});
      if (!prepared.ok) throw new Error('shipping');
      let data = null;
      for (let attempt = 0; attempt < 8; attempt++) {
        await new Promise(resolve => setTimeout(resolve, 750));
        const response = await fetch(root + 'cart/async_shipping_rates.json?' + params, {headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('shipping');
        data = await response.json();
        if (data) break;
      }
      if ((revisions.get(panel) || 0) !== revision) return;
      if (!data) throw new Error('timeout');
      result.textContent = data.shipping_rates.length ? data.shipping_rates.map(rate => {
        const price = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:rate.currency || panel.dataset.currency}).format(Number(rate.price));
        return (rate.presentment_name || rate.name) + ': ' + price;
      }).join('\n') : panel.dataset.none;
    } catch (_) { if ((revisions.get(panel) || 0) === revision) result.textContent = panel.dataset.error; }
    finally { button.disabled = false; }
  });
})();
